<!-- Template reutilizable para la información de actividades -->
<ng-template #actividadesInfo>
  <div class="header">
    <div class="header-info">
      <h1><strong>Código: {{ bodyActividades.code }}</strong></h1>
      @if (bodyActividades.componentName) {
      <h2><strong>Componente: {{ bodyActividades.componentName }}</strong></h2>
      }
    </div>
  </div>

  <div class="info-list">
    <mat-list>
      <mat-list-item>
        <span matListItemTitle>Creada por:</span>
        {{ bodyActividades.creatorUser }}
      </mat-list-item>
      <mat-divider />

      <mat-list-item>
        <span matListItemTitle>Medidor actual (horas/km/ciclos):</span>
        {{ bodyActividades.currentOdometer | thousandSeparator }}
      </mat-list-item>
      <mat-divider />

      <mat-list-item>
        <span matListItemTitle>Frecuencia (días):</span>
        {{ bodyActividades.timeFrequency }}
      </mat-list-item>
      <mat-divider />

      <mat-list-item>
        <span matListItemTitle>Frecuencia uso (horas/km/ciclos):</span>
        {{ bodyActividades.odometerFrequency | thousandSeparator }}
      </mat-list-item>
      <mat-divider />

      @if (!viewCarousel) {
      <mat-list-item>
        <span matListItemTitle>Recursos:</span>
        {{ bodyActividades.resources }}
      </mat-list-item>
      <mat-divider />
      }

      <mat-list-item>
        <span matListItemTitle>Fecha próxima actividad:</span>
        {{ bodyActividades.lastMttoDate }}
      </mat-list-item>
      <mat-divider />

      <mat-list-item>
        <span matListItemTitle>Lectura última actividad:</span>
        {{ bodyActividades.odometerLastMtto | number:'1.0-0' }}
      </mat-list-item>
      <mat-divider />

      <mat-list-item>
        <span matListItemTitle>Costo:</span>
        {{ bodyActividades.cost | number:'1.0-0' }}
      </mat-list-item>
      <mat-divider />

      <mat-list-item class="description-item" lines="4">
        <span matListItemTitle>Descripción:</span>
        <div class="description-text">{{ bodyActividades.description }}</div>
      </mat-list-item>
      <mat-divider />
    </mat-list>
  </div>
</ng-template>

<mat-dialog-content>
  @if (bodyActividades) {
  @if (viewCarousel) {
  <app-carousel>
    <ng-template carouselItem="1">
      <div class="content-container">
        <ng-container *ngTemplateOutlet="actividadesInfo" />
      </div>
    </ng-template>

    <ng-template carouselItem="2">
      <div>
        <h2 style="display: flex; justify-content: center;">
          <strong>Recursos</strong>
        </h2>
        <data-table [title]="''" [columns]="columnsResouces" [configuration]="configurationResouces"
          [url]="urlGetTablaResourcesActivity" [params]="paramsResources" (internalData)="dataResources($event)" />
      </div>
    </ng-template>
  </app-carousel>
  } @else {
  <div class="content-container">
    <ng-container *ngTemplateOutlet="actividadesInfo" />
  </div>
  }
  <div class="button-container">
    <button class="button-save mat-elevation-z5" color="primary" mat-raised-button (click)="OT()">
      Crear orden de trabajo
    </button>
  </div>
  }
</mat-dialog-content>